module.exports = __webpack_public_path__ + "img/ads.57688dc1.jpg";